import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BaseComponent } from '../classes/BaseComponent';
import { Config } from '../classes/Config';
import { environment } from '../../environments/environment';
import { CrashReportService } from '../crash-report.service';
import { Log } from '../helpers/Log';
import { ContextInfoHelper } from '../helpers/ContextInfoHelper';

@Component({
  selector: 'app-home-footer',
  templateUrl: './home-footer.component.html',
  styleUrls: ['./home-footer.component.scss']
})
export class HomeFooterComponent extends BaseComponent implements OnInit {

  constructor(
    private crashReportService: CrashReportService,
    private router: Router
  ) {
    super();
  }

  ngOnInit() {
  }

  showAmazon(): boolean {
    return Config.showAmazonUS;
  }

  get version() {
    return `v. ${environment.versionMajor}.${environment.versionMinor}.${environment.versionPatch}`;
  }

  sendLogToServer() {
    console.log('sendLogToServer called');

    // Manually add a log entry to ensure we have something to send
    Log.getInstance().d('Manual log send triggered by user');

    const logHistory = Log.getInstance().getLogHistory();
    console.log('logHistory:', logHistory);
    console.log('logHistory length:', logHistory ? logHistory.length : 0);

    // Collect context information
    const contextInfo = ContextInfoHelper.collectContextInfo(this.router);

    if (logHistory && logHistory.length > 0) {
      console.log('Sending log to server...');
      this.crashReportService.sendError(logHistory, undefined, contextInfo).subscribe(
        (res) => {
          console.log('Log sent successfully:', res);
          // Log sent successfully - no action needed
        }, (err) => {
          console.error('Log sending failed:', err);
          // Log sending failed - no action needed
        });
    } else {
      console.log('No log history to send');
      // Even if no history, send current browser info with context
      const currentLog = ['Manual log send - no log history available'];
      console.log('Sending minimal log with browser info...');
      this.crashReportService.sendError(currentLog, undefined, contextInfo).subscribe(
        (res) => {
          console.log('Minimal log sent successfully:', res);
        }, (err) => {
          console.error('Minimal log sending failed:', err);
        });
    }
  }

}
